<template>
  <div>
    <b-tabs
      pills
      fill
    >
      <b-tab active>
        <template #title>
          <feather-icon icon="InfoIcon" />
          <span>Ürün Bilgisi</span>
        </template>
        <info-form />
        <b-button
            variant="primary"
            @click="submitForm"
        >
          Kaydet
        </b-button>
      </b-tab>
      <b-tab
        :disabled="!itemData.id"
      >
        <template #title>
          <feather-icon icon="CameraIcon" />
          <span>Teknik Parametreler</span>
        </template>
        <technical-parameters :item-id="itemData.id"/>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BTabs,
  BTab,
  BButton,
} from 'bootstrap-vue'
import InfoForm from '@/views/Admin/Products/Forms/InfoForm.vue'
import ImageGallery from '@/views/Admin/Products/Forms/PhotoGallery.vue'
import VideoGallery from '@/views/Admin/Products/Forms/VideoGallery.vue'
import FileForm from '@/views/Admin/Products/Forms/FileForm.vue'
import PriceForm from '@/views/Admin/Products/Forms/PriceForm.vue'
import TechnicalParameters from "@/views/Admin/Products/Forms/TechnicalParameters.vue";
import ProductFeaturesForm from "@/views/Admin/Products/Forms/FeaturesForm.vue";
import ItemsCard from "@/views/Admin/Products/elements/itemsCard.vue";
import ItemsCard2 from "@/views/Admin/Products/elements/itemsCard2.vue";
import ItemsCard3 from "@/views/Admin/Products/elements/itemsCard3.vue";

export default {
  name: 'ItemForm',
  components: {
    ItemsCard,
    ProductFeaturesForm,
    TechnicalParameters,
    BTabs,
    BTab,
    BButton,
    InfoForm,
    PriceForm,
    ImageGallery,
    VideoGallery,
    FileForm,
    ItemsCard2,
    ItemsCard3,
  },
  props: {
    submitForm: {
      type: Function,
      required: true,
    },
  },
  computed: {
    itemData() {
      return this.$store.getters['products/dataItem']
    },
  },
  created() {
    this.getProductGroups()
  },
  methods: {
    getProductGroups() {
      this.$store.dispatch('productGroups/getDataList', {
        select: [
          'product_categories.id AS id',
          'product_categories.title AS title',
          'pc.title AS main_group',
        ],
        where: {
          'product_categories.id_product_categories ': null,
        },
      })
    },
  },
}
</script>
